import { Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

export function InfoHint({ text, testid }) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-testid={testid}
            aria-label="How to find this"
            className="inline-flex h-4 w-4 items-center justify-center rounded-full text-muted-foreground hover:text-primary transition-colors"
          >
            <Info className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="start"
          className="max-w-xs bg-popover text-popover-foreground border border-border leading-relaxed font-body normal-case tracking-normal"
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
